var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInstallmentLate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 225,
    viewBox: "0 0 156 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "79.717%",
    x2: "50%",
    y1: "75.706%",
    y2: "35.636%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C3FFA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "42.276%",
    x2: "55.76%",
    y1: "78.4%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#323A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "3.49%",
    x2: "142.052%",
    y1: "12.64%",
    y2: "133.068%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F67878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F041B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "15.676%",
    x2: "75.598%",
    y1: "78.4%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#323A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "7.938%",
    x2: "85.388%",
    y1: "46.387%",
    y2: "56.528%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#425461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1F2A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "100%",
    x2: "13.765%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C3FFA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "93.926%",
    x2: "12.266%",
    y1: "77.413%",
    y2: "26.257%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C3FFA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "7.938%",
    x2: "85.388%",
    y1: "46.802%",
    y2: "55.779%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#425461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1F2A32"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M51.562 28.201c8.935-11.485-.783-2.519 11.309-4.858 6.255-1.21 5.288-14.914-1.24-17.435-10.684-4.126-5.686 7.052-9.971 11.883-5.566 6.274-17.286.087-5.74 8.096 1.291.896 2.902 1.262 4.354 1.894l1.288.42z",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2A32",
    fillRule: "nonzero",
    d: "M52.503 12.856c-1 .423 3.653 8.914-3.242 4.571-.142-.09-.968 1.281-.862 1.73.144.617 1.134.696.862 1.061-.778 1.042-2.673.304-3.73 1.651-1.603 2.043-4.916.1-5.338-1.65-.437-1.817-.645-3.805-.144-5.604.864-3.103 1.96-6.36 4.136-8.73 1.32-1.438 3.63-1.522 5.554-1.825 2.146-.337 9.443-4.455 10.723-2.714 4.326 5.878 4.31 6.325-7.959 11.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M51.66 28.584c5.244.66 22.791.694 30.448 6.048 1.274.891 3.01 2.299 2.788 3.959-.442 3.283-3.346 5.543-4.478 8.613-5.16 13.996-11.154 42.284-29.924 42.83-7.518.22-3.411 7.418-7.316 0-2.938-5.582-7.512-21.915-10.358-27.556-5.985-11.866-2.215-37.345 10.358-41.098",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    d: "M67.009 114.05c4.724 15.318 6.457 29.72 5.2 43.205-1.259 13.485-6.17 33.143-14.732 58.974l11.265.222c17.78-26.764 28.756-48.55 32.93-65.36 4.172-16.809 3.017-34.582-3.467-53.32l-31.196 16.28z",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M68.349 8.241l48.189 81.038c4.154 6.986-1.04 15.721-9.35 15.721H10.812c-8.31 0-13.504-8.735-9.35-15.721L49.651 8.24c4.154-6.988 14.544-6.988 18.698 0z",
    transform: "translate(38 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M103.277 68.5H92.723L90 1h16l-2.723 67.5zM98 91c-4.364 0-8-3.545-8-7.5 0-4.09 3.636-7.5 8-7.5s8 3.41 8 7.5c0 3.955-3.636 7.5-8 7.5z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M2.586 11.137c19.76-6.03 32.98-9.442 39.66-10.235 6.678-.794 12.139.4 16.38 3.58 4.761 8.968 7.922 19.81 9.484 32.522 1.561 12.714 1.561 27.613 0 44.7l-9.484 2.578-16.38-54.783c-4.29 4.123-9.463 8.447-15.52 12.974C20.67 47 11.762 53.2 0 61.073l2.586-49.936z",
    transform: "rotate(94 -1.362 99.524)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M60.04 75.635c-.149.243-6.779 10.06-4.419 11.207 3.194 1.553 6.544-2.314 9.873-2.99 5.47-1.108 11.1-.614 16.491-2.354 8.465-2.731 4.042-3.978-3.393-4.38-6.466-.349-12.937.29-19.405.434",
    transform: "rotate(64 -31.883 79.758)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "nonzero",
    d: "M133.72 31.864c-24.69-5.184-10.514 15.271-.295.491l.294-.49z",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "nonzero",
    d: "M46.726 66.515c-.79 7.221-2.01 14.41-2.37 21.665-.113 2.286-1.053 5.7.96 6.8 13.324 7.28 36.033 3.063 42.33 16.851l1.35.826c.15.328-.206.82-.549.931-8.687 2.846-45.065-5.935-52.411-11.702-6.189-4.859-12.972-29.397-11.2-33.86 1.414-3.558 16.229-.268 19.58.334l2.31-1.845z",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "nonzero",
    d: "M34.17 30c11.532 4.763 23.233 30.635 14.726 36.974C11.422 94.896 22.72 42.016 33.01 31.072L34.17 30z",
    transform: "translate(-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "nonzero",
    d: "M58.31 214.087c-.15.229-6.806 9.492-4.442 10.571 3.198 1.46 6.56-2.19 9.897-2.83 5.483-1.052 11.123-.593 16.528-2.24 8.486-2.585 4.055-3.755-3.394-4.125-6.479-.322-12.964.288-19.447.432",
    transform: "translate(-4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInstallmentLate);
export default __webpack_public_path__ + "static/media/user-installment-late.782c6535a23bb82de66c0914f01bcb6f.svg";
export { ForwardRef as ReactComponent };